import { Route, Routes } from "react-router-dom";

import Home from "./bundles/home/components/Home";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

export default AppRoutes;